import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ContactPerson } from '../interfaces/contact_people';
import { BASEURL } from '../constant/url';
import { catchError, map, Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ContactPeopleService {
  private readonly _http = inject(HttpClient);

  add(data: any): Observable<ContactPerson> {
    return this._http.post<any>(`${BASEURL}contact-people`, data).pipe(catchError(this.handleError));
  }

  edit(data: ContactPerson, id: number): Observable<ContactPerson> {
    return this._http.put<ContactPerson>(
      `${BASEURL}contact-people/${id}`,
      data
    ).pipe(catchError(this.handleError));
  }

  delete(id: number): Observable<any> {
    return this._http.delete<any>(`${BASEURL}contact-people/${id}`).pipe(catchError(this.handleError));
  }

  private handleError = (error: HttpErrorResponse) => {
    let errorMessage = 'Error en el servicio de Personas de Contacto.';
    if (error.error && error.error.error && error.error.error.message) {
      errorMessage = error.error.error.message;
    } else if (error.message) {
      errorMessage = error.message;
    }
    console.error('ContactPeopleService error:', errorMessage, error.error || error);
    return throwError(() => new Error(errorMessage));
  }
}
